export default {
      id: "icon-time-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.svg#icon-time",
      toString: function () {
        return this.url;
      }
    }